import { render, staticRenderFns } from "./AnthropometricsEditModal.vue?vue&type=template&id=1d867390"
import script from "./AnthropometricsEditModal.vue?vue&type=script&lang=js"
export * from "./AnthropometricsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports